import { LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon, SimpleGeometry } from 'ol/geom';
import { useContext, useEffect } from 'react';
import { selectFitGeom } from '../../../../features/mapSlice';
import { useAppSelector } from '../../../../store/hooks';
import MapContext from '../MapContext';

export default function MapFit(props?: any) {
    const fitGeom = useAppSelector(selectFitGeom);
    const map = useContext(MapContext)
    const layer = useAppSelector(state => state.layer.layer);

    useEffect(() => {
        if (props.featureArray && props.featureArray.length === 1) {
            map.getView().fit(props.featureArray[0] as SimpleGeometry, { duration: 500, maxZoom: 15 })
        }
    }, [props.featureArray])

    useEffect(() => {
        if (fitGeom) {
            let geom;
            switch (fitGeom.type) {
                case 'Point':
                    geom = new Point(fitGeom.coordinates)
                    break;
                case 'LineString':
                    geom = new LineString(fitGeom.coordinates)
                    break;
                case 'Polygon':
                    geom = new Polygon(fitGeom.coordinates)
                    break;
                case 'MultiPoint':
                    geom = new MultiPoint(fitGeom.coordinates)
                    break;
                case 'MultiLineString':
                    geom = new MultiLineString(fitGeom.coordinates)
                    break;
                case 'MultiPolygon':
                    geom = new MultiPolygon(fitGeom.coordinates)
                    break;
                default:
                    break;
            }

            const translated = geom?.transform('EPSG:4326', 'EPSG:3857');
            if (translated) {
                if (layer && (layer.name === 'uip_1000' || layer.name === 'eb_uip_1000' || layer.name === 'tgb_uip_1000')) {
                    map.getView().fit(translated as SimpleGeometry, { duration: 500, maxZoom: 15 })
                }
                else {
                    map.getView().fit(translated as SimpleGeometry, { duration: 500, maxZoom: 19 })
                }
            }
        }
    }, [fitGeom, layer])


    return (
        <></>
    )
}
